<script>
import useSharedData from "@/use/SharedData.js";
import {computed, onMounted, ref, watch} from "vue";

import useSharedMethod from "@/use/SharedMethod.js";
import useTools from "@/use/Tools.js";
import useValidation from "@/use/Validation.js";
import {useRecruitmentPlanningStore} from "@/stores/Recruitment/RecruitmentPlanning.js";
import axios from "axios";
import {storeToRefs} from "pinia";
import {useEvaluationInterviewStore} from "@/stores/Evaluation/EvaluationInterview";
import DejaVu from "@/views/Recruitment/Sourcing/Components/DejaVu.vue";

export default {
    components: {DejaVu},
    props: {
        addAction: Boolean,
        updateAction: Boolean,
        deleteAction: Boolean,
        viewAction: Boolean,
        lockAction: Boolean,
        type: String,
    },
    setup(props) {
        const readonly = computed(() => props.deleteAction || props.viewAction || props.lockAction);
        const {dialog, loading, overlay} = useSharedData();
        const {getBack, formatedTime} = useSharedMethod();
        const {$route, $i18n, $router, $refs} = useTools();
        const {mxRules} = useValidation();

        const planning = ref({
            sourcingId: $route.params.id,
            typeId: null,
            timing: null,
            expertIds: [],
            recruitmentCandidates: [],
        });
        const experts = ref([{}]);

        const sourcing = ref({});
        const cvTechSourcings = ref([]);
        const selectedCvTechSourcings = ref([]);

        function findSourcingById(id) {
            loading.value = true;
            axios.get(`/recruitmentSourcings/${id}`).then(response => {
                sourcing.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }

        const loadingCvTechSourcing = ref(false);

        function findSelectedCvTechSourcings() {
            if (planning.value.typeId) {
                loadingCvTechSourcing.value = true;
                axios.get('/cvTechSourcings/findNotAssigned', {
                    params: {
                        sourcingId: planning.value.sourcingId,
                        planningId: planning.value.id,
                        planningTypeId: planning.value.typeId,
                    }
                }).then(response => {
                    cvTechSourcings.value = response.data;
                }).finally(() => {
                    loadingCvTechSourcing.value = false;
                });
            }
        }

        const date = ref(null);

        const cvTechHeaders = [
            {
                text: "",
                sortable: false,
                align: "left",
                value: "action",
                width: "0%"
            },
            {
                text: $i18n.t('common.last_name'),
                sortable: true,
                align: "left",
                value: "lastName",
                width: "0%"

            },
            {
                text: $i18n.t('common.first_name'),
                sortable: true,
                align: "left",
                value: "firstName",
                width: "0%"
            },
            {
                text: $i18n.t('common.phone'),
                sortable: true,
                align: "left",
                value: "phone",
                width: "0%"
            },
            {
                text: "",
                sortable: false,
                align: "left",
                value: "dejaVu",
            }
        ];

        const selectedCandidateHeaders = [
            {
                text: "",
                sortable: false,
                align: "left",
                value: "action",
                width: "0px"
            },
            {
                text: $i18n.t('common.last_name'),
                sortable: false,
                align: "left",
                value: "cvTechLastName",
                width: "0%"
            },
            {
                text: $i18n.t('common.first_name'),
                sortable: false,
                align: "left",
                value: "cvTechFirstName",
                width: "0%"
            },
            {
                text: $i18n.t('common.hour'),
                sortable: false,
                align: "left",
                value: "timing",
                width: "0%"
            },
            {
                text: $i18n.t('common.confirmed'),
                sortable: false,
                align: "left",
                value: "confirmed",
                width: "0%"
            },

        ];

        if (props.type === 'EVALUATION') {
            selectedCandidateHeaders.push(
                {
                    text: $i18n.t('common.absent'),
                    sortable: false,
                    align: "left",
                    value: "absent",
                    width: "0%"
                },
                {
                    text: $i18n.t('common.done'),
                    sortable: false,
                    align: "left",
                    value: "done",
                    width: "0%"
                },
                {
                    text: $i18n.t('common.decision'),
                    sortable: false,
                    align: "left",
                    value: "interviewDecision",
                    width: "0%"
                },
                {
                    text: $i18n.t('common.note'),
                    sortable: false,
                    align: "left",
                    value: "interviewNote",
                    width: "0%"
                },
            );
        }

        selectedCandidateHeaders.push(
            {
                text: "",
                sortable: false,
                align: "left",
                value: "dejaVu",
            },
            {
                text: $i18n.t('common.observation'),
                sortable: false,
                align: "left",
                value: "description",
            },
        );

        const candidates = computed(() => {
            let result = [];
            cvTechSourcings.value.forEach(e => {
                if (isNotSelected(e))
                    result.push(e);
            });
            return result;
        });

        function isNotSelected(cvTechSourcing) {
            return planning.value.recruitmentCandidates.findIndex(e => e.cvTechSourcingId === cvTechSourcing.id) === -1;
        }

        function addCandidate(item) {
            planning.value.recruitmentCandidates.unshift({
                cvTechSourcingId: item.id,
                cvTechSourcingState: item.state,
                cvTechSourcingCvTech: item.cvTech,
                confirmed: false,
                done: false,
            });
        }

        function removeCandidate(item) {
            let index = planning.value.recruitmentCandidates.findIndex(e => e.cvTechSourcingId === item.cvTechSourcingId);
            if (index !== -1) {
                planning.value.recruitmentCandidates.splice(index, 1);
            }
        }

        function findById(id) {
            loading.value = true;
            axios.get(`/recruitmentPlannings/${id}`).then(response => {
                planning.value = response.data;
                planningStore.updateRecruitmentPlanning(planning.value);
                findSourcingById(planning.value.sourcingId);
                findSelectedCvTechSourcings();
                experts.value = planning.value.expertIds.map(number => {
                    return {id: number};
                });
            }).finally(() => {
                loading.value = false;
            })
        }

        const planningStore = useRecruitmentPlanningStore();

        function save() {
            if ($refs.form.validate()) {
                planning.value.sourcingId = $route.params.id;
                // planning.value.expertIds = experts.value.map(e => e.id);
                loading.value = true;
                axios.post('/recruitmentPlannings', planning.value).then(() => {
                    getBack();
                }).finally(() => {
                    loading.value = false;
                });
            }
        }

        function update(close) {
            if ($refs.form.validate()) {
                loading.value = true;
                axios.put('/recruitmentPlannings', planning.value).then(response => {
                    planningStore.updateRecruitmentPlanning(response.data);
                    if (close)
                        getBack();
                }).finally(() => {
                    loading.value = false;
                });
            }
        }

        function lock() {
            if (props.type === 'PLANNING') {
                planning.value.closed = true;
            } else if (props.type === 'EVALUATION') {
                planning.value.evaluationClosed = true;
            }
            update(true);
        }

        function remove() {
            loading.value = true;
            axios.delete(`/recruitmentPlannings/${planning.value.id}`).then(() => {
                planningStore.deleteRecruitmentPlanning(planning.value);
                getBack();
            }).finally(() => {
                loading.value = false;
            });
        }

        function evaluate(item) {
            $router.push({name: `evaluation_recruitment_plans.interview.${item.done ? 'view' : 'edit'}`, params: {id: item.id}});
        }

        function view(item) {
            $router.push({name: "recruitment_sourcings.planning.recruitment_cv_techs.view", params: {id: item.id}});
        }

        function viewCandidateCvTech(item) {
            goToCvTech(item.cvTechSourcingCvTech.id);
        }

        function viewCvTech(item) {
            goToCvTech(item.cvTech.id);
        }

        function goToCvTech(id) {
            let action = 'add';
            if (props.updateAction) {
                action = 'edit';
            } else if (props.viewAction) {
                action = 'view';
            } else if (props.lockAction) {
                action = 'lock';
            } else if (props.deleteAction) {
                action = 'delete';
            }
            $router.push({name: `${props.type === 'PLANNING' ? 'recruitment_plannings' : 'recruitment_evaluations'}.${action}.cv_techs.view`, params: {id: id}});
        }

        function setTime(item) {
            item.confirmed = !!item.timing;
        }

        const evaluationInterviewStore = useEvaluationInterviewStore();
        const {refresh} = storeToRefs(evaluationInterviewStore);

        watch(() => refresh.value, () => {
            findById($route.params.id);
        });


        onMounted(() => {
            if (props.addAction) {
                findSourcingById($route.params.id);
            } else {
                findById($route.params.id);
            }
        });


        return {
            setTime,
            readonly,
            mxRules,
            dialog,
            loading,
            overlay,
            cvTechHeaders,
            sourcing,
            planning,
            experts,
            selectedCvTechSourcings,
            selectedCandidateHeaders,
            candidates,
            date,
            getBack,
            view,
            addCandidate,
            removeCandidate,
            viewCandidateCvTech,
            viewCvTech,
            save,
            update,
            lock,
            remove,
            evaluate,
            formatedTime,
            findSelectedCvTechSourcings
        }
    }
}
</script>

<template>
    <div>
        <v-dialog
            v-model="dialog"
            persistent
            scrollable
            max-width="1400"
        >
            <v-card>
                <w-dialog-toolbar
                    :add-action="addAction"
                    :update-action="updateAction"
                    :delete-action="deleteAction"
                    :view-action="viewAction"
                    :lock-action="lockAction"
                    :title="sourcing.requestOccupationName"
                ></w-dialog-toolbar>
                <w-overlay
                    :loading="loading"
                    :overlay="overlay"
                    :delete-action="deleteAction"
                    :lock-action="lockAction"
                    @remove="remove"
                    @lock="lock"
                    @cancel="overlay = false"
                ></w-overlay>
                <v-card-text>
                    <v-form ref="form" lazy-validation>
                        <v-container fluid>
                            <w-fieldset :title="$t('common.details')">
                                <v-row dense>
                                    <v-col cols="12" md="3">
                                        <w-label :label="$t('recruitment_request.planning_date')" required/>
                                        <w-date-picker
                                            v-model="planning.date"
                                            :readonly="readonly"
                                            :rules="[mxRules.required]"
                                        />
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <w-label :label="$t('recruitment_request.planning_time')" required/>
                                        <w-time-picker
                                            v-model="planning.timing"
                                            :readonly="readonly"
                                            :rules="[mxRules.required]"
                                        />
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <w-label :label="$t('data_select.RECRUITMENT_PLANNING_TYPE')" required/>
                                        <w-data-select-autocomplete
                                            v-model="planning.typeId"
                                            type="RECRUITMENT_PLANNING_TYPE"
                                            :readonly="readonly"
                                            :rules="[mxRules.required]"
                                            @input="findSelectedCvTechSourcings"
                                        />
                                    </v-col>
                                    <v-col cols="3">
                                        <w-label :label="$t('recruitment_request.principal_expert')" required/>
                                        <str-worker-autocomplete
                                            v-model="planning.principalExpertId"
                                            :readonly="readonly"
                                            :rules="[mxRules.required]"
                                        ></str-worker-autocomplete>
                                    </v-col>
                                    <v-col cols="12">
                                        <w-label :label="$t('recruitment_request.experts')" required/>
                                        <str-worker-autocomplete
                                            v-model="planning.expertIds"
                                            :readonly="readonly"
                                            multiple
                                            :rules="[mxRules.required]"
                                        ></str-worker-autocomplete>
                                    </v-col>
                                </v-row>
                            </w-fieldset>
                            <br/>
                            <w-fieldset
                                v-if="!readonly"
                                :title="$t('recruitment_request.candidates')"
                            >
                                <w-data-table
                                    :headers="cvTechHeaders"
                                    :items="candidates"
                                    sort-by="lastName"
                                    disable-pagination
                                    fixed-header
                                    height="200"
                                    @rowDbClick="viewCvTech"
                                >
                                    <template v-slot:item.action="{ item }">
                                        <v-btn
                                            :disabled="readonly"
                                            icon
                                            color="teal"
                                            @click="addCandidate(item)"
                                        >
                                            <v-icon>mdi-arrow-down</v-icon>
                                        </v-btn>
                                    </template>
                                    <template v-slot:[`item.lastName`]="{ item }">
                                        <w-chip color="blue darken-2" :text="item.cvTech.lastName"/>
                                    </template>
                                    <template v-slot:[`item.firstName`]="{ item }">
                                        <w-chip color="blue darken-2" :text="item.cvTech.firstName"/>
                                    </template>
                                    <template v-slot:[`item.phone`]="{ item }">
                                        <w-chip :text="item.cvTech.phone"/>
                                    </template>
                                    <template v-slot:[`item.dejaVu`]="{ item }">
                                        <DejaVu
                                            ref="dejaVue"
                                            small
                                            :cv-tech-sourcing-id="item.id"
                                        />
                                    </template>
                                </w-data-table>
                            </w-fieldset>
                            <br/>
                            <w-fieldset :title="$t('recruitment_request.selected_candidate')">
                                <w-data-table
                                    :headers="selectedCandidateHeaders"
                                    :items="planning.recruitmentCandidates"
                                    disable-pagination
                                    fixed-header
                                    height="350"
                                    @rowDbClick="viewCandidateCvTech"
                                >
                                    <template v-slot:[`item.action`]="{ item }">
                                        <v-btn
                                            v-if="type === 'PLANNING'"
                                            :disabled="readonly"
                                            icon
                                            color="red"
                                            @click="removeCandidate(item)"
                                        >
                                            <v-icon>mdi-arrow-up</v-icon>
                                        </v-btn>
                                        <v-btn
                                            v-if="readonly && type === 'EVALUATION'"
                                            :disabled="!item.confirmed || item.absent"
                                            icon
                                            color="blue darken -2"
                                            @click="evaluate(item)"
                                        >
                                            <v-icon>mdi-clipboard-text-clock</v-icon>
                                        </v-btn>
                                    </template>
                                    <template v-slot:[`item.cvTechLastName`]="{ item }">
                                        <w-chip color="blue darken-2" :text="item.cvTechSourcingCvTech.lastName"/>
                                    </template>
                                    <template v-slot:[`item.cvTechFirstName`]="{ item }">
                                        <w-chip color="blue darken-2" :text="item.cvTechSourcingCvTech.firstName"/>
                                    </template>
                                    <template v-if="readonly" v-slot:item.timing="{item}">
                                        <w-chip outlined :text="formatedTime(item.timing)"/>
                                    </template>
                                    <template v-else v-slot:item.timing="{item}">
                                        <v-edit-dialog
                                            :return-value.sync="item.timing"
                                            large
                                            @save="setTime(item)"
                                            persistent
                                        >

                                            <w-chip outlined :text="formatedTime(item.timing)" icon="mdi-pencil"/>
                                            <template v-slot:input>
                                                <div class="mt-4 text-h6">
                                                    {{ $t('recruitment_request.planning_time') }}
                                                </div>
                                                <w-time-picker v-model="item.timing"/>
                                            </template>
                                        </v-edit-dialog>
                                    </template>
                                    <template v-slot:[`item.confirmed`]="{ item }">
                                        <v-simple-checkbox
                                            :value="item.confirmed"
                                            color="blue"
                                        />
                                    </template>
                                    <template v-slot:[`item.absent`]="{ item }">
                                        <v-checkbox
                                            v-model="item.absent"
                                            @change="update(false)"
                                            :readonly="item.done"
                                            color="red"
                                            class="mt-n1"
                                            hide-details
                                        />
                                    </template>
                                    <template v-slot:[`item.done`]="{ item }">
                                        <v-simple-checkbox :value="item.done" color="blue"/>
                                    </template>
                                    <template v-slot:[`item.interviewDecision`]="{ item }">
                                        <w-chip :text="item.interviewDecision && item.done ? $t(`recruitment_request.evaluation_decision_${item.interviewDecision}`) : ''"/>
                                    </template>
                                    <template v-slot:[`item.interviewNote`]="{ item }">
                                        <w-chip
                                            color="blue darken-2"
                                            outlined
                                            :text="item.interviewNote && item.done ? item.interviewNote : ''"
                                        />
                                    </template>
                                    <template v-slot:[`item.description`]="{ item }">
                                        <span v-if="readonly">{{ item.description }}</span>
                                        <v-edit-dialog
                                            v-else
                                            :return-value.sync="item.description"
                                            large
                                            persistent
                                        >
                                            {{ item.description }}
                                            <v-btn icon small>
                                                <v-icon small color="orange">mdi-pencil</v-icon>
                                            </v-btn>
                                            <template v-slot:input>
                                                <v-container fluid>
                                                    <w-simple-text-area
                                                        v-model="item.description"
                                                        :label="$t('common.observation')"
                                                    />
                                                </v-container>
                                            </template>
                                        </v-edit-dialog>
                                    </template>
                                    <template v-slot:[`item.dejaVu`]="{ item }">
                                        <DejaVu
                                            ref="dejaVue"
                                            small
                                            :cv-tech-sourcing-id="item.cvTechSourcingId"
                                        />
                                    </template>
                                </w-data-table>
                            </w-fieldset>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <w-btn-close @press="getBack"/>
                    <w-btn-add
                        :show="addAction"
                        :loading="loading"
                        @press="save"
                    />
                    <w-btn-update
                        :show="updateAction"
                        :loading="loading"
                        @press="update(true)"
                    />
                    <w-btn-lock
                        :show="lockAction"
                        :loading="loading"
                        @press="overlay = true"
                    />
                    <w-btn-delete
                        :show="deleteAction"
                        :loading="loading"
                        @press="overlay = true"
                    />
                </v-card-actions>
            </v-card>
        </v-dialog>

        <router-view/>
    </div>
</template>